<template>
    <div class="navbar sm:h-5 sm:items-center">
        <div>
           <router-link to="/"><a> <svg xmlns="http://www.w3.org/2000/svg" width="29.828" height="30" viewBox="0 0 29.828 30" class="relative"><path id="Path_12" data-name="Path 12" d="M39.274,22.053,27.836,10.442a1.7,1.7,0,0,0-.441-.32,3.318,3.318,0,0,0-2.962,0,1.693,1.693,0,0,0-.441.32L12.554,22.053a3.315,3.315,0,0,0,1.761,6.123h.829V36.46a3.317,3.317,0,0,0,3.314,3.314H33.371a3.317,3.317,0,0,0,3.314-3.314V28.176h.828a3.315,3.315,0,0,0,1.761-6.123Zm-.148,3.19a1.656,1.656,0,0,1-1.613,1.276H35.028V36.46a1.657,1.657,0,0,1-1.657,1.657H18.458A1.657,1.657,0,0,1,16.8,36.46V26.519H14.315a1.657,1.657,0,0,1-.741-3.139l11.6-11.774a1.659,1.659,0,0,1,1.482,0l11.6,11.774A1.656,1.656,0,0,1,39.126,25.242Z" transform="translate(-11.001 -9.774)" fill="#082f2a"></path></svg>
            </a></router-link>
        </div>
        <img v-if="$i18n.locale=='en'" :src="logoEn" class="logo">
         <img v-if="$i18n.locale=='fr'" :src="logoFr" class="logo">
        <div>
            <div class="btn-language"v-for="language in languages" v-if="language!= $i18n.locale" @click="changeLocale(language)">{{language}}</div>
        </div>
    </div>
</template>
<script>
import logoFr from '../assets/images/Logo-Ramo-EcransVerts-Foret.png';
import logoEn from '../assets/images/Logo-Ramo-GreenBarriers-Foret.png';
import {i18n} from '../plugins/i18n';
export default {
    data: function () {
        return {
            logoFr,
            logoEn,
            languages:['en', 'fr']
        }
   },
    methods: {    
        changeLocale(locale) {
            i18n.locale= locale;    
        }
    },
    mounted() {
        let local=navigator.language || navigator.userLanguage;
         
         if(local=='en' || local=='en-US' ){
            i18n.locale='en';
         }
    },
       
}
</script>
<style scoped>
.navbar{
    display:flex;
    justify-content:space-between;
    height:40px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background-color:white;
    padding-left:20px;
    padding-right:20px;
}
.telephone{
    color: rgba(8,47,42);
}
.logo{
    height:100%;
}
.btn-language{
    height:30px;
    width: 30px;
    border-radius:50%;
    border:2px solid  rgba(8,47,42);
    display:flex;
    justify-content: center;
    align-items: center;
    font-family: Styrene A Web;
    color: rgba(8,47,42);
    cursor: pointer;
    font-weight: bold;
    transition: ease-in-out 0.5s;
}
.btn-language:hover{
    background-color: rgba(8,47,42);
    color:white;
}
</style>


// WEBPACK FOOTER //
// src/components/NavBar.vue